module.exports = __webpack_public_path__ + "static/media/We.4c8f181a.svg";